import React, { useEffect } from 'react';
import FooterSimple from '../common/footer/FooterSimple';
import HeaderPos from '../common/header/HeaderPos';
import SEO from '../common/SEO';
import BannerHome from '../component/banner/BannerHome';
import CtaLayoutOne from '../component/cta/CtaLayoutOne';
import CardanoTimelineArea2022 from '../component/timelines/CardanoTimelineArea2022';
import CardanoTimelineArea2023 from '../component/timelines/CardanoTimelineArea2023';
import CardanoTimelineArea2024 from '../component/timelines/CardanoTimelineArea2024';
import CardanoTimelineArea2025 from '../component/timelines/CardanoTimelineArea2025';
import ResearchTimelineArea2025 from '../component/timelines/ResearchTimelineArea2025';
import RoadMapCTimelines from '../component/roadmap/RoadMapCTimelines';
import ColorSwitcher from '../elements/switcher/ColorSwitcher';
import ReactGA from 'react-ga';

const Home = () => {

    useEffect(() => {
        ReactGA.pageview('/home');
    }, []);

    return (
        <>
        <SEO title="Home"/>
        <ColorSwitcher />
        <main className="main-wrapper">
            <HeaderPos />            
            <BannerHome />
            <div className="bg-color-light">        
                <div className="container">                
                   <CardanoTimelineArea2025 />
                </div>  
            </div> 
            <div className="bg-color-light-two">        
                <div className="container">                
                   <ResearchTimelineArea2025 />
                </div>  
            </div>  
            <div className="bg-color-light">        
                <div className="container">                
                    <CardanoTimelineArea2024 />
                </div>  
            </div>
            <div className="bg-color-light-two">        
                <div className="container">                
                   <CardanoTimelineArea2023 />
                </div>  
            </div>  
            <div className=" bg-color-light">                               
                <div className="container">                
                    <CardanoTimelineArea2022 />
                </div>
            </div>
            <RoadMapCTimelines />
            <CtaLayoutOne /> 
            <FooterSimple />
        </main>
        </>
    )
}

export default Home;

